import React from 'react';
import "../css/Pagination.css"

const Pagination = ({ pages, active, onClick }) => (
  <div className="pagination">
    {[...Array(pages)].map((_e, index) => (
      <div
        className={`pagination-circle ${index === active ? 'active' : ''}`}
        onClick={() => onClick(index)}
      />
    ))}
  </div>
);

export default Pagination;
